import request from '@/utils/httpRequest'

// 列表页
export function getDeclareList (menuId, query) {
  return request({
    url: `/api/culture/management/web/management/${menuId}/list`,
    method: 'get',
    params: query
  })
}

//  详情页
export function getDeclareDetail (id) {
  return request({
    url: `/api/culture/management/web/management/${id}/detail`,
    method: 'get'
  })
}
// // 详情页管理申报列表
// export function getListrDec (menuId, query) {
//   return request({
//     url: `/api/culture/management/web/declareContent/${menuId}/list`,
//     method: 'get',
//     params: query
//   })
// }

// 申报记录
export function getRecordList (menuId, query) {
  return request({
    url: `/api/culture/management/web/declareContent/${menuId}/uploadList`,
    method: 'get',
    params: query
  })
}

// 新增申报人

export function addNewPer (query) {
  return request({
    url: '/api/culture/management/web/declarationUser/upload',
    method: 'get',
    params: query
  })
}

//  申报人列表
// /api/culture/management/web/declarationUser/list
export function addPerList () {
  return request({
    url: '/api/culture/management/web/declarationUser/list',
    method: 'get'
  })
}

// 提交个人申报
// /api/culture/management/web/declareContent/${menuId}/upload
export function submitAll (menuId, query) {
  return request({
    url: `/api/culture/management/web/declareContent/${menuId}/upload`,
    method: 'get',
    params: query
  })
}

export function uploads (query) {
  return request({
    url: '/api/file/upload',
    method: 'post',
    // headers: {'Content-Type': 'multipart/form-data'},
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/declare/index.js